exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.loader-container>*, .progress-bar-container>*{\n    text-align: center;\n}\n\n.progress {\n    height: 3em !important;\n    font-size: 100% !important;\n}\n\n.progress-bar-container {\n    padding: 20% 10%;\n}", ""]);

